<template>
  <main :class="stageClass">
    <img
      alt=""
      class="header__hud-glyph"
      src="/images/graphics/hud-glyph.svg">
    <div class="unm__background background__welcome"/>
    <div class="unm__background background__intro"/>
    <div class="unm__background background__quiz"/>
    <div
      :class="{quiz__ended: quizEnded}"
      class="unm__background background__results"/>
    <div class="unm__background background__complete"/>
    <div class="unm__background background__end"/>
    <transition mode="out-in">
      <keep-alive include="TheQuestion,TheAnswer,TheResults">
        <component :is="is"/>
      </keep-alive>
    </transition>
    <TheProgress/>
  </main>
</template>

<script>
  import { mapState } from 'vuex';

  import TheEnd from '@/components/TheEnd';
  import TheIntro from '@/components/TheIntro';
  import TheAnswer from '@/components/TheAnswer';
  import TheWelcome from '@/components/TheWelcome';
  import TheResults from '@/components/TheResults';
  import TheQuestion from '@/components/TheQuestion';
  import TheComplete from '@/components/TheComplete';
  import TheProgress from '@/components/TheProgress';


  export default {
    name: 'TheMain',
    components: {
      TheEnd,
      TheIntro,
      TheAnswer,
      TheWelcome,
      TheResults,
      TheQuestion,
      TheComplete,
      TheProgress,
    },
    computed: {
      stageClass() {
        return `stage__${this.stage}`;
      },
      is() {
        const { stage } = this.$store.state;

        return `The${stage.charAt(0).toUpperCase()}${stage.slice(1)}`;
      },
      ...mapState(['activeQuestion', 'stage', 'overlayColor', 'quizEnded']),
    },
  };
</script>

<style scoped lang="scss">
  .unm__background {
    @include z-index(background-overlay);
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
    transform: translateZ(0);
    user-select: none;
    pointer-events: none;
    background-blend-mode: multiply;
}

.stage__welcome {
  .background__welcome {
    opacity: 1;
  }
}


.background__welcome {
  opacity: 0;
  background-image:
    url("/images/graphics/statue.png"),
    url("/images/graphics/red-texture.png");
  background-size: cover, 50px;
  background-repeat: no-repeat, repeat;
}

.stage__intro {
  .background__intro {
    opacity: 1;
  }
}

.background__intro {
    opacity: 0;
    background-image:
      url("/images/backgrounds/background-glyph-01.svg"),
      url("/images/graphics/blue-texture.png");
    background-size: cover, 50px;
    background-repeat: no-repeat, repeat;
}

.stage__question,
.stage__answer {
  .background__quiz {
    opacity: 1;
  }
}

.background__quiz {
    opacity: 0;
    background-image:
      url("/images/backgrounds/transparent1.svg"),
      url("/images/graphics/white-texture.png");
    background-size: cover, 50px;
    background-repeat: no-repeat, repeat;
}

.stage__results {
  .background__results {
    opacity: 1;
  }
}

.background__results {
    opacity: 0;
    background-image:
      url("/images/backgrounds/transparent.svg"),
      url("/images/graphics/white-texture.png");
    background-size: cover, 50px;
    background-repeat: no-repeat, repeat;

    &.quiz__ended {
      background-image:
        url("/images/backgrounds/transparent.svg"),
        url("/images/graphics/red-texture.png");
      background-size: cover, 50px;
      background-repeat: no-repeat, repeat;
    }
}

.stage__complete {
  .background__complete {
    opacity: 1;
  }
}

.background__complete {
  opacity: 0;
  background-image:
    url("/images/backgrounds/background-glyph-01.svg"),
    url("/images/graphics/blue-texture.png");
  background-size: cover, 50px;
  background-repeat: no-repeat, repeat;
}

.stage__end {
  .background__end {
    opacity: 1;
  }
}

.background__end {
  opacity: 0;
  background-image:
    url("/images/backgrounds/background-glyph-01.svg"),
    url("/images/graphics/red-texture.png");
  background-size: cover, 50px;
  background-repeat: no-repeat, repeat;
}

.stage__question,
.stage__answer {
  .header__hud-glyph {
    opacity: 0.12;
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }
}

.header__hud-glyph {
  position: absolute;
  left: 50%;
  top: 0;
  @include z-index(content);
  width: 35px;
  margin-left: calc(-35px / 2);
  opacity: 0;
  transition-duration: $stage-transition-duration;
  transition-property: opacity;
  transition-timing-function: $transition-timing-function;
  user-select: none;
  pointer-events: none;

  @include breakpoint(large) {
    width: 50px;
    margin-left: -25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheMain.vue